<template>
    <b-modal hide-footer id="appModal" size="lg" title="E-correção App">
        <p class="text-center">Agora você pode baixar a versão beta do nosso app para envio de redações nas lojas de aplicativos do seu celular</p>
        <div class="mx-3 mt-auto mb-1 w-100">
            <div class="d-flex flex-1 align-items-center justify-content-center gap-1" >
                <a href='https://play.google.com/store/apps/details?id=com.ecorrecao.student_app&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
                    <img 
                    class="w-100 flex-fill"
                    style="max-width: 125px; width: 125px;"
                    alt='Disponível no Google Play' 
                    src='https://play.google.com/intl/en_us/badges/static/images/badges/pt-br_badge_web_generic.png'
                    />
                </a>   
                <a href="https://apps.apple.com/br/app/e-corre%C3%A7%C3%A3o/id6504528203?itsct=apps_box_badge&amp;itscg=30200" style="display: inline-block; overflow: hidden; border-radius: 1px;">
                    <img
                    class="w-100"
                    src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/pt-br?size=250x83&amp;releaseDate=1719360000" 
                    alt="Download on the App Store" 
                    style="border-radius: 5px; max-width: 125px; width: 125px;">
                </a>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    data(){
        return {
            
        }
    },
    created(){
        if(!localStorage.getItem('appAlert')){

            this.$nextTick(() => {
                    this.$bvModal.show('appModal')
            })
            localStorage.setItem('appAlert', false);
        }
    },
    methods: {
        
    }
}
</script>

<style>

</style>
